import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import retardUpdate from '../../../lib/react/update-retarder';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEResizeObserver from '../../../lib/components/oe-resize-observer';
import OEToolbox from '../../../lib/tools/oe-toolbox';
import OEPopover from '../../views/oe-popover';
import {OEGroupControl, OEControl, OEIconButtonGroupControl} from '../../elements/controls/oe-controls';
import {OENoteFlags, OENoteViewerEditFlags, OENoteExtControllerBtnIds, OENoteModels} from './oe-note-model';
import OEObjectModelValueEdit from '../../elements/object-model-value-edit/oe-object-model-value-edit';

export class OENoteExtController extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.id = typeof(this.props.id) === 'number' ? this.props.id : null;

        this.style = null;

        this.state = this.defaultState();
        
        this.updateLanguage = this.updateLanguage.bind(this);
        this.onNoteStyleChanged = this.onNoteStyleChanged.bind(this);
        this.onNoteFlagsChanged = this.onNoteFlagsChanged.bind(this);
        this.onNoteViewerEditParamsChanged = this.onNoteViewerEditParamsChanged.bind(this);
        this.onNoteImageChanged = this.onNoteImageChanged.bind(this);
        this.onNoteHiddenChanged = this.onNoteHiddenChanged.bind(this);
        this.onNoteDisabledChanged = this.onNoteDisabledChanged.bind(this);
        this.onNoteActiveChanged = this.onNoteActiveChanged.bind(this);
        this.onNoteZIndexChanged = this.onNoteZIndexChanged.bind(this);
        this.onNoteTextIDChanged = this.onNoteTextIDChanged.bind(this);
        this.onNoteUserRefChanged = this.onNoteUserRefChanged.bind(this);
        this.onNoteVisibilityCheckSizeChanged = this.onNoteVisibilityCheckSizeChanged.bind(this);
        this.onNoteVisibilityCheckRefChanged = this.onNoteVisibilityCheckRefChanged.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onRTFFileLoadInputRef = this.onRTFFileLoadInputRef.bind(this);
        this.onImageFileLoadInputRef = this.onImageFileLoadInputRef.bind(this);

        this.onResize = this.onResize.bind(this);

        this.onTextButtonPressed = this.onTextButtonPressed.bind(this);
        this.onImageButtonPressed = this.onImageButtonPressed.bind(this);
        this.onStyleChange = this.onStyleChange.bind(this);
        this.onPositioningChange = this.onPositioningChange.bind(this);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);
        this.onMiscChange = this.onMiscChange.bind(this);
        this.onRTFFileLoadInputResult = this.onRTFFileLoadInputResult.bind(this);
        this.onImageFileLoadInputResult = this.onImageFileLoadInputResult.bind(this);
    }

    defaultState()  {
        return {
            uiEnabled:              false,
            style:                  this.style,
            positioning:            null,
            visibility:             null,
            misc:                   null,
            miscModelModifier:      {viewEditParams: {disabled: true}},
            hasImage:               false,
            strings: {
                styleLabel:         '',
                textBtnGroupLabel:  '',
                imageBtnGroupLabel: '',
                positioningLabel:   '',
                visibilityLabel:    '',
                miscLabel:          ''
            }
        };
    }

    viewerEditFlagsToParams(flags)  {
        return {
            singleLine:             !!(flags & OENoteViewerEditFlags.singleLine),
            autosave:               !!(flags & OENoteViewerEditFlags.autosave),
        };
    }

    viewerEditFlagsFromParams(params) {
        let ret = OENoteViewerEditFlags.none;
        if(params.singleLine)       ret = ret | OENoteViewerEditFlags.singleLine;
        if(params.autosave)         ret = ret | OENoteViewerEditFlags.autosave;
        return ret;
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.id !== this.props.id)  {
            this.id = typeof(nextProps.id) === 'number' ? nextProps.id : null;
            this.updateNoteStyle();
            this.updateNotePositioning();
            this.updateNoteVisibility();
            this.updateNoteMisc();
            this.updateNoteState();
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteStyleChanged, this.onNoteStyleChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteFlagsChanged, this.onNoteFlagsChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteViewerEditParamsChanged, this.onNoteViewerEditParamsChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteImageChanged, this.onNoteImageChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteHiddenChanged, this.onNoteHiddenChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteDisabledChanged, this.onNoteDisabledChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteActiveChanged, this.onNoteActiveChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteZIndexChanged, this.onNoteZIndexChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteTextIDChanged, this.onNoteTextIDChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteUserRefChanged, this.onNoteUserRefChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteVisibilityCheckSizeChanged, this.onNoteVisibilityCheckSizeChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.noteVisibilityCheckRefChanged, this.onNoteVisibilityCheckRefChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteStyleChanged, this.onNoteStyleChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteFlagsChanged, this.onNoteFlagsChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteViewerEditParamsChanged, this.onNoteViewerEditParamsChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteImageChanged, this.onNoteImageChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteHiddenChanged, this.onNoteHiddenChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteDisabledChanged, this.onNoteDisabledChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteActiveChanged, this.onNoteActiveChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteZIndexChanged, this.onNoteZIndexChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteTextIDChanged, this.onNoteTextIDChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteUserRefChanged, this.onNoteUserRefChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteVisibilityCheckSizeChanged, this.onNoteVisibilityCheckSizeChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.noteVisibilityCheckRefChanged, this.onNoteVisibilityCheckRefChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);	
    }

    updateLanguage()   {
        if(!this.oe.isReady())  return;

        this.setState({
            strings: {
                styleLabel:         this.oe.sharedInterface.getLocalizedStringEnc('note_ext_view_style'),
                textBtnGroupLabel:  this.oe.sharedInterface.getLocalizedStringEnc('note_ext_view_text_btn_group'),
                imageBtnGroupLabel: this.oe.sharedInterface.getLocalizedStringEnc('note_ext_view_image_btn_group'),
                positioningLabel:   this.oe.sharedInterface.getLocalizedStringEnc('note_ext_view_positioning'),
                visibilityLabel:    this.oe.sharedInterface.getLocalizedStringEnc('note_ext_view_visibility'),
                miscLabel:          this.oe.sharedInterface.getLocalizedStringEnc('note_ext_view_misc'),
            }
        });
    }

    updateNoteStyle(style)  {
        if((!this.oe.isReady() || this.id === null) && !style)    return;

        let style_ = style || this.oe.sharedInterface.getUIControllerNote().getNoteStyle(this.id);

        this.style = {
            hAlignment:             style_.hAlignment,
            vAlignment:             style_.vAlignment,
            padding:                style_.padding,
            cornerRadius:           style_.cornerRadius,
            textColor:              style_.textColor,
            backgroundColor:        style_.backgroundColor,
            borderColor:            style_.borderColor,
            lineColor:              style_.lineColor,
            hasBorder:              style_.hasBorder,
            fontSize:               style_.fontSize,
            showAlways:             style_.showAlways,
            maxWidth:               style_.maxWidth > 0 ? Math.max(0, style_.maxWidth) : undefined,
            maxScreenRelWidth:      style_.maxScreenRelWidth > 0 ? Math.max(0, style_.maxScreenRelWidth) : undefined,
            intrinsicSize:          {x: style_.intrinsicSize.x > 0 ? Math.max(0, style_.intrinsicSize.x) : undefined, y: style_.intrinsicSize.y > 0 ? Math.max(0, style_.intrinsicSize.y) : undefined},
            linkPointSize:          style_.linkPointSize
        };

        this.setState({style: clone(this.style)});
    }

    updateNotePositioning() {
        if(!this.oe.isReady() || this.id === null)    return;

        let positioning = {
            zIndex:                 this.oe.sharedInterface.getUIControllerNote().getNoteZIndex(this.id)
        };

        this.setState({positioning: positioning});
    }

    updateNoteVisibility() {
        if(!this.oe.isReady() || this.id === null)    return;

        let visibilityCheckSize = this.oe.sharedInterface.getUIControllerNote().getNoteVisibilityCheckSize(this.id);
        if(typeof(visibilityCheckSize) === 'number')    visibilityCheckSize *= 100;

        let visibility = {
            visibilityCheckSize:    visibilityCheckSize,
            visibilityCheckRef:     this.oe.sharedInterface.getUIControllerNote().getNoteVisibilityCheckRef(this.id)
        };

        this.setState({visibility: visibility});
    }

    updateNoteMisc() {
        if(!this.oe.isReady() || this.id === null)    return;

        let flags = this.oe.sharedInterface.getUIControllerNote().getNoteFlags(this.id);
        let viewerEditParams = this.oe.sharedInterface.getUIControllerNote().getNoteViewerEditParams(this.id);
        let hidden = this.oe.sharedInterface.getUIControllerNote().getNoteHidden(this.id);
        let disabled = this.oe.sharedInterface.getUIControllerNote().getNoteDisabled(this.id);
        let active = this.oe.sharedInterface.getUIControllerNote().getNoteActive(this.id);

        let misc = Object.assign(
            {
                userRef:                    this.oe.sharedInterface.getUIControllerNote().getNoteUserRef(this.id),
                textID:                     this.oe.sharedInterface.getUIControllerNote().getNoteTextID(this.id),
                hidden:                     hidden,
                disabled:                   disabled,
                escaping:                   !!(flags & OENoteFlags.stringEscaping),
                textViewerEditable:         !!(flags & OENoteFlags.textViewerEditable),
                activeViewerEditable:       !!(flags & OENoteFlags.activeViewerEditable),
                active:                     active,
                linkPointViewerEditable:    !!(flags & OENoteFlags.linkPointViewerEditable),
                maxTextLength:              viewerEditParams.maxTextLength > 0 ? viewerEditParams.maxTextLength : undefined
            },
            this.viewerEditFlagsToParams(viewerEditParams.flags)
        );

        this.setState({misc: misc});
    }

    updateNoteState()   {
        if(!this.oe.isReady() || this.id === null)    return;
        let controller = this.oe.sharedInterface.getUIControllerNote();

        this.setState({
            hasImage:               controller.hasNoteImage(this.id),
        });
    }

    updateNoteMiscModelModifier()   {
        if(!this.oe.isReady())  return;

        let flags = this.oe.sharedInterface.getUIControllerNote().getNoteFlags(this.id);

        let viewEditParams = {disabled: !(flags & OENoteFlags.viewerEditable)};

        if(!viewEditParams.disabled && !(flags & OENoteFlags.textViewerEditable))    {
            viewEditParams.subItems = {
                singleLine:         {disabled: true},
                maxTextLength:      {disabled: true}
            }
        }

        this.setState({
            miscModelModifier:      {viewEditParams: viewEditParams}
        });
    }

    updateUIState()    {
        if(!this.oe.isReady())  return;

        this.setState({
            uiEnabled:              this.oe.sharedInterface.getUIControllerNote().getUIEnabled()
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released)   {
            this.style = null;
            this.setState(this.defaultState());
            return;
        }

        retardUpdate(this, () => {
            this.updateLanguage();
            this.updateUIState();
            this.updateNoteStyle();
            this.updateNotePositioning();
            this.updateNoteVisibility();
            this.updateNoteMisc();
            this.updateNoteState();
            this.updateNoteMiscModelModifier();
        });
    }

    onNoteStyleChanged(message, userInfo)   {
        if(userInfo.ID !== this.id)  return;
        this.updateNoteStyle(userInfo.style);
    }

    onNoteFlagsChanged(message, userInfo) {
        if(userInfo.ID !== this.id)  return;
        this.updateNoteMisc();
        this.updateNoteMiscModelModifier();
    }

    onNoteViewerEditParamsChanged(message, userInfo) {
        if(userInfo.ID !== this.id)  return;
        this.updateNoteMisc();
    }

    onNoteImageChanged(message, userInfo)   {
        if(userInfo.ID !== this.id)  return;
        this.updateNoteState();
    }

    onNoteHiddenChanged(message, userInfo)  {
        if(userInfo.ID !== this.id)  return;
        this.updateNoteMisc();
    }

    onNoteDisabledChanged(message, userInfo)  {
        if(userInfo.ID !== this.id)  return;
        this.updateNoteMisc();
    }
    
    onNoteActiveChanged(message, userInfo)  {
        if(userInfo.ID !== this.id)  return;
        this.updateNoteMisc();
    }

    onNoteZIndexChanged(message, userInfo)   {
        if(userInfo.ID !== this.id)  return;
        this.updateNotePositioning();
    }

    onNoteTextIDChanged(message, userInfo)   {
        if(userInfo.ID !== this.id)  return;
        this.updateNoteMisc();
    }

    onNoteUserRefChanged(message, userInfo)   {
        if(userInfo.ID !== this.id)  return;
        this.updateNoteMisc();
    }

    onNoteVisibilityCheckSizeChanged(message, userInfo)   {
        if(userInfo.ID !== this.id)  return;
        this.updateNoteVisibility();
    }

    onNoteVisibilityCheckRefChanged(message, userInfo)   {
        if(userInfo.ID !== this.id)  return;
        this.updateNoteVisibility();
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.note) {
            this.updateUIState();
        }
    }

    onRTFFileLoadInputRef(ref)  {
        this.rtfFileLoadInput = ref;
    }

    onImageFileLoadInputRef(ref)  {
        this.imageFileLoadInput = ref;
    }

    onResize(sender, size) {
        if(this.props.onResize) this.props.onResize(this, size);
    }

    render()    {
        let disabled = !this.state.uiEnabled;

        return (
            <React.Fragment>
                <input
                    type="file"
                    accept=".rtf"
                    ref={this.onRTFFileLoadInputRef}
                    style={{display: 'none'}}
                    onChange={this.onRTFFileLoadInputResult}
                />

                <input
                    type="file"
                    accept=".jpg,.png,.bmp"
                    ref={this.onImageFileLoadInputRef}
                    style={{display: 'none'}}
                    onChange={this.onImageFileLoadInputResult}
                />

                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                
                <div className={'note-ext-controller ' + this.props.className}>

                    {!this.props.onResize ? null :
                        <OEResizeObserver onResize={this.onResize}/>
                    }

                    <OEGroupControl title={this.state.strings.styleLabel}>
                        <OEIconButtonGroupControl
                            title={this.state.strings.textBtnGroupLabel}
                            disabled={disabled}
                            buttons={[
                                {
                                    id: OENoteExtControllerBtnIds.loadRTFFile,
                                    icon: OEIconCodes.noteRTFFileLoad
                                }
                            ]}
                            onPressed={this.onTextButtonPressed}
                        />

                        <OEIconButtonGroupControl
                            title={this.state.strings.imageBtnGroupLabel}
                            disabled={disabled}
                            buttons={[
                                {
                                    id: OENoteExtControllerBtnIds.loadImage,
                                    icon: OEIconCodes.noteImageLoad
                                },
                                {
                                    id: OENoteExtControllerBtnIds.dumpImage,
                                    disabled: !this.state.hasImage,
                                    icon: OEIconCodes.noteImageDump
                                }
                            ]}
                            onPressed={this.onImageButtonPressed}
                        />

                        <OEControl>
                            <OEObjectModelValueEdit
                                className="multi-column"
                                disabled={disabled}
                                model={OENoteModels.styleExt}
                                object={this.state.style}
                                onChange={this.onStyleChange}
                            />
                        </OEControl>
                    </OEGroupControl>

                    <OEGroupControl title={this.state.strings.positioningLabel}>
                        <OEControl>
                            <OEObjectModelValueEdit
                                className="multi-column"
                                disabled={disabled}
                                model={OENoteModels.positioning}
                                object={this.state.positioning}
                                onChange={this.onPositioningChange}
                            />
                        </OEControl>
                    </OEGroupControl>

                    <OEGroupControl title={this.state.strings.visibilityLabel}>
                        <OEControl>
                            <OEObjectModelValueEdit
                                className="multi-column"
                                disabled={disabled}
                                model={OENoteModels.visibility}
                                object={this.state.visibility}
                                onChange={this.onVisibilityChange}
                            />
                        </OEControl>
                    </OEGroupControl>

                    <OEGroupControl title={this.state.strings.miscLabel}>
                        <OEControl>
                            <OEObjectModelValueEdit
                                className="multi-column"
                                disabled={disabled}
                                model={OENoteModels.misc}
                                modelModifier={this.state.miscModelModifier}
                                object={this.state.misc}
                                onChange={this.onMiscChange}
                            />
                        </OEControl>
                    </OEGroupControl>

                </div>
            </React.Fragment>
        );
    }

    onTextButtonPressed(sender, id) {
        if(!this.oe.isReady() || this.id === null) return;

        if(id === OENoteExtControllerBtnIds.loadRTFFile)    {
            if(!this.rtfFileLoadInput) return;
            this.rtfFileLoadInput.value = null;             // empties the file list so that onRTFFileLoadInputResult gets called when loading the same file multiple times successively
            this.rtfFileLoadInput.click();
        }
    }

    onImageButtonPressed(sender, id)  {
        if(!this.oe.isReady() || this.id === null) return;

        if(id === OENoteExtControllerBtnIds.loadImage)    {
            if(!this.imageFileLoadInput) return;
            this.imageFileLoadInput.value = null;           // empties the file list so that onImageFileLoadInputResult gets called when loading the same file multiple times successively
            this.imageFileLoadInput.click();
        } else if(id === OENoteExtControllerBtnIds.dumpImage) {
            this.oe.sharedInterface.getUIControllerNote().setNoteImage(this.id, undefined);
        }
    }

    onStyleChange(sender, params) {
        if(!this.oe.isReady() || this.id === null || this.style === null) return;

        let style = {
            hAlignment:             this.style.hAlignment,
            vAlignment:             this.style.vAlignment,
            padding:                this.style.padding,
            cornerRadius:           this.style.cornerRadius,
            textColor:              this.style.textColor,
            backgroundColor:        this.style.backgroundColor,
            borderColor:            this.style.borderColor,
            lineColor:              this.style.lineColor,
            hasBorder:              this.style.hasBorder,
            fontSize:               this.style.fontSize,
            showAlways:             this.style.showAlways,
            maxWidth:               typeof(params.maxWidth) === 'number' && params.maxWidth > 0 ? params.maxWidth : 0,
            maxScreenRelWidth:      typeof(params.maxScreenRelWidth) === 'number' && params.maxScreenRelWidth > 0 ? params.maxScreenRelWidth : 0,
            intrinsicSize:          {x: typeof(params.intrinsicSize.x) === 'number' && params.intrinsicSize.x > 0 ? params.intrinsicSize.x : 0, y: typeof(params.intrinsicSize.y) === 'number' && params.intrinsicSize.y > 0 ? params.intrinsicSize.y : 0},
            linkPointSize:          this.style.linkPointSize
        };

        this.oe.sharedInterface.getUIControllerNote().setNoteStyle(this.id, style);
    }

    onPositioningChange(sender, params) {
        if(!this.oe.isReady() || this.id === null) return;

        this.oe.sharedInterface.getUIControllerNote().setNoteZIndex(this.id, params.zIndex);
    }

    onVisibilityChange(sender, params)  {
        if(!this.oe.isReady() || this.id === null) return;

        let visibilityCheckSize = params.visibilityCheckSize;
        if(typeof(visibilityCheckSize) === 'number')    visibilityCheckSize *= 0.01;

        this.oe.sharedInterface.getUIControllerNote().setNoteVisibilityCheckSize(this.id, visibilityCheckSize);
        this.oe.sharedInterface.getUIControllerNote().setNoteVisibilityCheckRef(this.id, params.visibilityCheckRef);
    }

    onMiscChange(sender, params)    {
        if(!this.oe.isReady() || this.id === null) return;
        let controller = this.oe.sharedInterface.getUIControllerNote();

        //
        controller.setNoteTextID(this.id, params.textID);

        controller.setNoteUserRef(this.id, params.userRef);

        //
        let flags = controller.getNoteFlags(this.id);
        flags = OEToolbox.binaryRemove(flags, OENoteFlags.stringEscaping | OENoteFlags.viewerEditable);

        if(params.escaping)                 flags = OEToolbox.binaryAdd(flags, OENoteFlags.stringEscaping);
        if(params.textViewerEditable)       flags = OEToolbox.binaryAdd(flags, OENoteFlags.textViewerEditable);
        if(params.activeViewerEditable)     flags = OEToolbox.binaryAdd(flags, OENoteFlags.activeViewerEditable);
        if(params.linkPointViewerEditable)  flags = OEToolbox.binaryAdd(flags, OENoteFlags.linkPointViewerEditable);

        controller.setNoteFlags(this.id, flags);

        //
        controller.setNoteHidden(this.id, params.hidden);
        controller.setNoteDisabled(this.id, params.disabled);
        controller.setNoteActive(this.id, params.active);

        //
        let viewerEditParams = controller.getNoteViewerEditParams(this.id);
        viewerEditParams.flags = OEToolbox.binaryRemove(viewerEditParams.flags, OENoteViewerEditFlags.singleLine | OENoteViewerEditFlags.autosave);

        viewerEditParams.flags = OEToolbox.binaryAdd(viewerEditParams.flags, this.viewerEditFlagsFromParams(params));

        viewerEditParams.maxTextLength = typeof(params.maxTextLength) === 'number' ? params.maxTextLength : 0;

        controller.setNoteViewerEditParams(this.id, viewerEditParams);
    }

    onRTFFileLoadInputResult(event) {
        event.stopPropagation();
        event.preventDefault();

        if(!this.oe.isReady() || this.id === null || !this.state.uiEnabled) return;

        OEToolbox.loadFiles(event, this.props.appComponent, (event, arrayBuffer) => {
            if(!this.oe.isReady() || this.id === null || !this.state.uiEnabled)  return;
            let si = this.oe.sharedInterface;

            let res = si.getUIControllerNote().setNoteTextRTF(this.id, arrayBuffer);
            if(res == this.oe.Module.NoteRTFResultType.ok)  {
                let flags = this.oe.sharedInterface.getUIControllerNote().getNoteFlags(this.id);
                flags = OEToolbox.binaryAdd(flags, OENoteFlags.stringEscaping);
                si.getUIControllerNote().setNoteFlags(this.id, flags);
                return;
            }

            if(this.props.appComponent && this.props.appComponent.module)   {
                this.props.appComponent.module.addModal(
                    si.getLocalizedStringEnc('alert_error_title'),
                    si.getLocalizedStringEnc('alert_note_rtf_load_msg_error'),
                    (id, container) => [{title: si.getLocalizedStringEnc('alert_ok'), onClick: () => { container.closeModal(id) }, className: 'btn-primary'}]
                );
            }
        });
    }

    onImageFileLoadInputResult(event)  {
        event.stopPropagation();
        event.preventDefault();

        if(!this.oe.isReady() || this.id === null || !this.state.uiEnabled) return;

        OEToolbox.loadFiles(event, this.props.appComponent, (event, arrayBuffer) => {
            if(!this.oe.isReady() || this.id === null || !this.state.uiEnabled)  return;
            this.oe.sharedInterface.getUIControllerNote().setNoteImageData(this.id, arrayBuffer);
        });
    }
}

OENoteExtController.defaultProps = {
    moduleId:                       '',
    className:                      ''
};

OENoteExtController.propTypes = {
    moduleId:                       PropTypes.string,
    className:                      PropTypes.string,
    id:                             PropTypes.number,
    onResize:                       PropTypes.func
}; 

//
export const OENoteExtPopoverController = OEPopover.coat(OENoteExtController, {
    noHeader:                       true,
}, {
    placement:                      'right',
    buttonClassName:                'transparent-btn',
    controllerClassName:            'note-ext-popover compact'
}, {
    controllerClassName:            PropTypes.string
});